import { createSlice } from "@reduxjs/toolkit";

import {
    getLeadHistoryAsync,
    retryLeadHistoryAsync,
} from "./leadHistory.asyncActions";
import { initialState } from "./leadHistory.types";

const readError = (
    payload: unknown,
    fallback: string | undefined,
): string =>
    typeof payload === "string" && payload
        ? payload
        : (fallback ?? "Request failed");

export const leadHistorySlice = createSlice({
    name: "leadHistory",
    initialState,
    reducers: {
        clearLeadHistory: () => ({
            leads: [],
            pagination: {
                current_page: 1,
                per_page: 10,
                total: 0,
                last_page: 1,
            },
            isLeadHistoryLoading: false,
            leadHistoryError: null,
            isRetryLoading: false,
            retryError: null,
            retryingStatId: null,
        }),
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLeadHistoryAsync.pending, (state) => {
                state.isLeadHistoryLoading = true;
                state.leadHistoryError = null;
            })
            .addCase(getLeadHistoryAsync.fulfilled, (state, action) => {
                state.isLeadHistoryLoading = false;
                state.leads = action.payload.leads;
                state.pagination = action.payload.pagination;
            })
            .addCase(getLeadHistoryAsync.rejected, (state, action) => {
                state.isLeadHistoryLoading = false;
                state.leadHistoryError = readError(
                    action.payload,
                    action.error.message,
                );
            })
            .addCase(retryLeadHistoryAsync.pending, (state, action) => {
                state.isRetryLoading = true;
                state.retryError = null;
                state.retryingStatId = action.meta.arg.stat_ids[0] ?? null;
            })
            .addCase(retryLeadHistoryAsync.fulfilled, (state) => {
                state.isRetryLoading = false;
                state.retryingStatId = null;
            })
            .addCase(retryLeadHistoryAsync.rejected, (state, action) => {
                state.isRetryLoading = false;
                state.retryingStatId = null;
                state.retryError = readError(
                    action.payload,
                    action.error.message,
                );
            });
    },
});

export default leadHistorySlice.reducer;
export const { clearLeadHistory } = leadHistorySlice.actions;
